import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ModalController } from "ionic-angular";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { ListComponent } from "../../components/listcomponent/listcomponent";
import { Committee } from "../../models/interfaces/committee.model";
import { Member } from "../../models/interfaces/member.model";
import { PaymentType } from "../../models/interfaces/paymenttype.model";
import { PaymentPage } from "../../pages/payment/payment";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-payment_add",
  templateUrl: "payment_add.html",
})
export class PaymentAddPage {

  private loading: any;
  private paymenttype$: Observable<PaymentType[]>;
  private paymentitem$: Observable<PaymentItem[]>;
  private member$: Observable<Member[]>;
  private memberForm: FormGroup;
  private paymentForm: FormGroup;
  private member: Member;
  private py_date: string = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate() + 1).toISOString().substring(0, 10);
  private pType;
  private smember: string;
  private smemberM: Member[];
  private styleName: string ="";
  private mb_hashname: string;
  private pm_type: string;
  private mb_id: string;
  private co_id: string;
  private pm_id: string;
  private py_remark: string;
  private py_amount: number;
  private settings_payment: any;
  private paymenttype = [];
  private committee: Committee;
  private committee$: any;

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController
    , private db: DbserviceProvider, public alertCtrl: AlertController,
    public loadingCtrl: LoadingController, public modalCtrl: ModalController,
  ) {
    console.log("PaymentAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");

    this.py_date = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate() + 1).toISOString().substring(0, 10);

    this.paymentForm = this.formBuilder.group({
      "co_id": [""],
      "mb_hashname": [""],
      "mb_id": [""],
      "mb_photo": [""],
      "mb_status": [""],
      "pm_id": [""],
      "pm_type": [""],
      "py_amount": [""],
      "py_date": ["", [Validators.required]],
      "py_remark": [""],
    });
  }

  private ionViewWillEnter() {
    console.log("PaymentAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("PaymentAddPage ionViewWillEnter");
    this.paymenttype$ = this.db.dbCol({
      "action": "select", "mapObject": "payment_type",
      "sqlExtended": " order by payment_type.pm_order",
    });

    // New Button is pressed
    if (this.navParams.data.id == null) {
      this.db.dbCol({
        "action": "select", "mapObject": "committee",
        "sqlExtended": " where committee.co_active_flg=1",
      }).subscribe((data) => {
        this.committee = data[0]
        this.co_id = this.committee.co_id;
      });
    }
    else /*A field (Insu, Q1.. of a certain member is pressed)*/ {
      this.mb_hashname = this.navParams.data.id.mb_hashname;
      this.pm_type = this.navParams.data.id.pm_type;
      this.mb_id = this.navParams.data.id.mb_id;
      this.co_id = this.navParams.data.id.co_id;
      this.pm_id = this.navParams.data.id.pm_id;
    }
    this.paymentForm.controls.mb_hashname.setValue(this.mb_hashname);
    this.paymentForm.controls.py_date.setValue(this.py_date);
    this.paymentForm.controls.pm_type.setValue(this.pm_type);
    this.paymentForm.controls.py_remark.setValue(this.py_remark);
    this.paymentForm.controls.mb_id.setValue(this.mb_id);
    this.paymentForm.controls.co_id.setValue(this.co_id);
    this.paymentForm.controls.pm_id.setValue(this.pm_id);

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Payment' order by se_class,se_order",
    }).subscribe((set) => {
      this.settings_payment = set;
      set.forEach((element) => {
        /* Insurance */
        if (this.navParams.data.id.pm_type === "Insu" && element.se_attribute1 === "Insu") {
          this.paymentForm.controls.py_amount.setValue(element.se_key_value);
        }
        /* Regular */
        if ((this.navParams.data.id.pm_type === "Q1" || this.navParams.data.id.pm_type === "Q2" ||
          this.navParams.data.id.pm_type === "Q3" || this.navParams.data.id.pm_type === "Q4")
          && this.navParams.data.id.mb_status === "Regular Member" && element.se_attribute1 === "Regular") {
          this.paymentForm.controls.py_amount.setValue(element.se_key_value);
        }
        /* LOA */
        if ((this.navParams.data.id.pm_type === "Q1" || this.navParams.data.id.pm_type === "Q2" ||
          this.navParams.data.id.pm_type === "Q3" || this.navParams.data.id.pm_type === "Q4")
          && this.navParams.data.id.mb_status === "LOA" && element.se_attribute1 === "LOA") {
          this.paymentForm.controls.py_amount.setValue(element.se_key_value);
        }
      });
    });
  }

  private selectMember(val) {
    console.log("PaymentAddPage selectMember");
    let selection = this.modalCtrl.create(ListComponent, { "obs": "member", "sel": val, "type": "S" });
    selection.present();
    selection.onDidDismiss((data) => {
      if (data != null) {
        this.smemberM = data;
        this.mb_hashname = data.map((v) => v.mb_hashname).toString();
        this.mb_id = data.map((v) => v.mb_id).toString();
        this.paymentForm.value.mb_id = this.mb_id;
      }
    });
  }

  private goback() {
    console.log("PaymentAddPage goback");
    this.navCtrl.pop();
  }

  private addPayment(value: any) {
    console.log("PaymentAddPage addPayment");

    if (this.navParams.data.id == null) {
      this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM payment WHERE payment.co_id=" + this.co_id + " and mb_id=" + this.mb_id + " and pm_id=" + this.paymentForm.value.pm_id })
        .subscribe((ret1) => {
          this.db.dbCol({ "action": "insert", "mapObject": "payment", "mb_id": this.mb_id, "co_id": this.co_id, "py_date": this.py_date, "pm_id": this.paymentForm.value.pm_id, "py_amount": this.paymentForm.value.py_amount, "py_remark": this.paymentForm.value.py_remark, })
            .subscribe((ret2) => {
              this.navCtrl.pop();
            });
        });
    }
    else {
      const formValues: any = {
        "co_id": this.co_id,
        "mb_id": this.mb_id,
        "pm_id": value.pm_id,
        "py_amount": value.py_amount,
        "py_date": value.py_date,
        "py_remark": value.py_remark,
      };
      this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM payment WHERE payment.co_id=" + this.co_id + " and mb_id=" + this.mb_id + " and pm_id=" + value.pm_id })
        .subscribe((ret1) => {
          this.db.dbCol({ "action": "insert", "mapObject": "payment", "co_id": this.co_id, "mb_id": this.mb_id, "pm_id": value.pm_id, "py_date": value.py_date, "py_amount": value.py_amount, "py_remark": value.py_remark })
            .subscribe((ret2) => {
              this.navCtrl.pop();
            });
        });
    }
  }

  private ngOnDestroy() {
    console.log("PaymentAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/payment/payment_add.ts